//import React, useState  from "react";
import React, { useState } from "react";

import { getUserRolePermission } from "../../_pages/_healthSafetyEnvironment/IncidentManagement/Helper";
import {
  UserWorkFlowRoleList,
  ACTIVE_MODULE,
  MINE_Work_Flow_Role_List,
  USER_Work_Flow_Role_List,
} from "../../_constants/constant";
import { GoPrimitiveDot } from "react-icons/go";
import { MdMoreVert } from "react-icons/md";

const ShowActiveModules = (props) => {
  const [isOpened, setIsOpened] = useState(false);
  const Permissions = getUserRolePermission();
  const globalScope =
    USER_Work_Flow_Role_List()?.filter(
      (x) =>
        (x.scope === ACTIVE_MODULE.global && x?.commonRole?.includes(props.module)) ||
        x.scope === props.module
    ) || [];
  function toggle() {
    setIsOpened((wasOpened) => !wasOpened);
  }
  // const Scope = USER_Work_Flow_Role_List()?.filter((y) => y.scope === props.module) || [];
  const finalScope = globalScope?.filter((d) => Permissions[d?.name]);
  return (
    <div className="iED_rolesList">
      {finalScope?.map((x, idx) => {
        return (
          idx <= 2 && (
            <ViewModule key={x.name} label={x.label} checked={Permissions[x?.name]} />
          )
        );
      })}

      {/* {(() => {
        switch (props.module) {
          case ACTIVE_MODULE.incident:
            return Scope?.map((x) => {
              return (
                <ViewModule key={x.name} label={x.label} checked={Permissions[x.name]} />
              );
            });

          case ACTIVE_MODULE.vfl:
            return Scope?.map((x) => {
              return (
                <ViewModule key={x.name} label={x.label} checked={Permissions[x.name]} />
              );
            });

          case ACTIVE_MODULE.training:
            return Scope?.map((x) => {
              return (
                <ViewModule
                  key={x?.name}
                  label={x?.label}
                  checked={Permissions[x?.name]}
                />
              );
            });

          case ACTIVE_MODULE.ohse: {
            return Scope.map((x) => {
              return (
                <>
                  <ViewModule
                    key={x.name}
                    label={x.label}
                    checked={Permissions[x.name]}
                  />
                </>
              );
            });
          }
          case ACTIVE_MODULE.meeting:
            return Scope.map((x) => {
              return (
                <>
                  <ViewModule
                    key={x.name}
                    label={x.label}
                    checked={Permissions[x.name]}
                  />
                </>
              );
            });
          default:
            return false;
        }
      })()} */}
      {finalScope?.length > 3 && (
        <MdMoreVert className="moreRolesIcon" onClick={toggle} />
      )}
      {isOpened && (
        <div className="moreRoles dropdown-menu">
          {finalScope?.map((x, idx) => {
            return (
              idx >= 3 && (
                <ViewModule key={x.name} label={x.label} checked={Permissions[x?.name]} />
              )
            );
          })}
        </div>
      )}
    </div>
  );
};

export const ViewModule = ({ label, checked }) => {
  return (
    <label className="checkbox-primary">
      {/* <input className="form-contorl" type="checkbox" checked={checked} readOnly /> */}
      <GoPrimitiveDot className="text-primary" size={16} />
      <span>{label}</span>
      {/* <span className="checkmark greencheck"></span> */}
    </label>
  );
};

export default ShowActiveModules;
